<p>app-campaign-manager works!</p>
